<template lang="pug">
  .column.width-100.max-width
    label.text-normal(v-if='label') {{ `${ label } ${ showRequiredMark ? `${$t('inputs.requiredMark')}` : ''}` }}
    vue-tags-input.tag-input.kimple-scroll.input-border.input-base(
      :add-from-paste='true'
      :avoid-adding-duplicates='avoidDuplicates'
      :separators='[";", ",", " "]'
      :style='style'
      :max-tags='maxTags'
      :placeholder='placeholder'
      v-model='tag'
      :tags='formattedTags'
      @tags-changed='tagsChanged($event)'
      @max-tags-reached='showTagError("Max")'
      @adding-duplicate='showTagError("Duplicate")'
      :class='{focus: isFocus}'
      @focus='focusInput'
      @blur='blurInput'
      :maxlength='maxLength'
      :add-on-key='[13, ";", ",", 32]'
      :validation='validTags ? tagsValidation : []'
    )
    .row(v-if='showDuplicateTagsError || showMaxTagsError')
      simple-svg.red-icon.m4-right-2(:filepath='errorIcon' :width='"16px"' :height='"16px"')
      span.error-desc(v-if='showDuplicateTagsError')
        | {{ $t('tagSelector.duplicatedWord') }}
      span.error-desc(v-else='showMaxTagsError')
        | {{ $t('tagSelector.wordsLimitReached') }}
    .row.top.m4-left-1(v-if='showError')
      simple-svg.error-icon.red-icon.m4-right-2(:filepath='errorIcon' :width='"16px"' :height='"16px"')
      span.text-small.red
        | {{ errorMessage }}
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input'
import errorIcon from '@/assets/ic_stop.svg'
import inputValidation from '@/mixins/inputsValidationMixin'

export default {
  components: { VueTagsInput },
  mixins: [inputValidation],
  props: {
    name: { type: String },
    avoidDuplicates: { type: Boolean, default: false },
    label: { type: String },
    tags: { type: Array, required: true, default: () => [] },
    placeholder: { type: String },
    updateMethod: { type: Function },
    maxTags: { type: Number, default: 10 },
    errorMessage: { type: String },
    showRequiredMark: { type: Boolean },
    validTags: { type: RegExp },
    maxHeight: { type: String, default: 'none' },
    maxLength: { type: Number, default: 35 },
    tagClass: { type: String }
  },
  data() {
    return {
      errorIcon,
      tag: '',
      showMaxTagsError: false,
      showDuplicateTagsError: false,
      isFocus: false
    }
  },
  computed: {
    formattedTags() {
      return this.tags.map(tag => ({ text: tag, classes: this.tagClass }))
    },
    tagsValidation() {
      return [{
        classes: 'tag-error',
        rule: this.validTags
      }]
    },
    style() {
      return {
        '--max-height': this.maxHeight
      }
    }
  },
  methods: {
    showTagError(type) {
      this[`show${type}TagsError`] = true
    },
    tagsChanged(value) {
      this.showMaxTagsError = false
      this.showDuplicateTagsError = false
      this.updateMethod(
        value.map(tag => tag.text),
        this.name
      )
    },
    focusInput() {
      this.verifyValidation()
      this.isFocus = true
    },
    blurInput() {
      this.isFocus = false
    }
  }
}
</script>

<style lang="scss">
@import "src/scss/variables/_colors";

.vue-tags-input{
  --max-width: auto !important;
  max-width: var(--max-width) !important;
  &.focus{
    border: 2px solid $blue;
  }
}

.max-width {
  max-width: var(--max-width);
}

.tag-input {
  min-height: 40px;
  height: auto;
  max-height: var(--max-height);
  padding: 0 !important;
  overflow-y: auto;

  .ti-input {
    border: none !important;
    padding: 2px;
    align-items: center;
  }

  .ti-tags{
    padding: 1px;
  }
  .ti-tag {
    background-color: $light-gray !important;
    border-radius: 5px !important;
    padding: 4px 16px !important;
    &.tag-error{
      background-color: $red !important;
      span{
        color: $white;
      }
      .ti-icon-close {
        color: $white;
        margin-left: 5px;
      }
    }

    span {
      color: $dark-gray;
      font-size: 16px;
      line-height: 19px;
    }
  }

  .ti-new-tag-input-wrapper {
    .ti-new-tag-input {
      font-size: 16px;
      line-height: 19px;
      min-width: 172px;
    }
  }

  .ti-icon-close {
    color: $black;
    margin-left: 5px;
  }
}
</style>
